export const presetLists = [
  'storyline-xapi',
  'rise-xapi',
  'dominknow-xapi',
];

export async function getPresetLists() {
  const presetPromiseList = presetLists.map(async p => {
    const fileName = p + '.json';

    const filePath = ['data', 'authoring-tools', fileName].join('/');

    const response = await fetch(filePath);

    if (response.ok) {
      return await response.json() as CustomList;
    }
  });

  const presetListData = await Promise.all(presetPromiseList);

  return presetListData.filter(Boolean) as CustomList[];
}